import React from "react";
import _ from 'lodash';
export const ConnectToSlack = ({
                                   renderErrorMessage,
                                   completedIdxs,
                                   slackError,
                                   suggestedEmail,
                                   suggestedToken,
                                   redirectUrl,
                                   base64TokenAndEmail,
                                   slackUnhappy
                               }) => {
    return <div className={"flexRowContainer step"} id="slack">
        <h3 className={"mb10"}>
            Let's connect to Slack
        </h3>
        <span>
            We use Slack for authentication and sending reminders.<br/><br/>

            If you're not using Slack yet, sign up free <a className={"setupLink"}
                                                           href="https://slack.com/get-started#/"
                                                           target="_blank" rel="noreferrer">here</a> first.<br/><br/>
            <b>You must be an administrator to integrate with Slack.</b><br/><br/>
            </span>
        <div className={"flexColumnContainer flexFill mt30"}>
            <div className={"flexFill"}/>
            {_.indexOf(completedIdxs, 2) < 0 ?
                <a href={"https://slack.com/oauth/v2/authorize?client_id=" + process.env.VITE_SLACK_CLIENT_ID + "&scope=channels:read,chat:write,chat:write.public,commands,team:read,users:read,users:read.email,im:read,im:write,mpim:read,mpim:write&user_scope=identify,im:read,im:write,mpim:read,mpim:write,users.profile:write&redirect_uri=" + redirectUrl + "/slack/add_to_workspace?token=" + base64TokenAndEmail}>
                    <img alt="Add to Slack" height="40" width="139"
                         src="https://platform.slack-edge.com/img/add_to_slack.png"
                         srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"/>
                </a> :
                <b className={"signupSuccessColor"}><i className={"fas fa-check"}/> Slack is already
                    connected</b>}
        </div>

        {slackError && <div className={'flexColumnContainer text-danger flexAlignCenter mt15'}>
            <span className={"fa fa-warning pr5"}/>
            <span><strong>This Slack account is already linked to an existing qube workspace. You can view that workspace by clicking <a
                className={"setupLink"}
                href={redirectUrl + "/setup?email=" + suggestedEmail + "&token=" + suggestedToken}>here</a></strong></span>

        </div>}
        {slackUnhappy && <div className={'flexColumnContainer text-danger flexAlignCenter mt15'}>
            <span className={"fa fa-warning pr5"}/>
            <span><strong>Sorry! It looks like Slack wasn't quite happy. Please try again.</strong></span>

        </div>}
        {renderErrorMessage()}
    </div>
}